<!--
 * @Author: zouyuping pingmeiniuzzz@163.com
 * @Date: 2022-05-07 16:10:17
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-05-07 17:04:59
 * @FilePath: \groupon-mobile\src\views\SelfHelp\SelectTeam.vue
 * @Description: 选择团队页面
-->

<template>
  <div class="select_team_con">
    <div class="select_title_con">
      <p>请确认您的同伴</p>
      <p class="c-lightgrey">同伴所点餐品互相可见，还可以请客买单哦！</p>
    </div>
    <ul class="select_team_list">
      <li v-for="item in teamList" :key="item.id">
        <div class="team_img_con">
          <div v-for="imgItem in item.list" :key="imgItem.id">
            <img :src="imgItem.photo" alt="" />
          </div>
        </div>
        <p>这是我的同伴，一起点餐</p>
      </li>
    </ul>
    <div class="select_footer_btn">
      <van-button color="#333" block round>没有我的同伴，我要自己点</van-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "SelectTeam",
  props: {},
  data() {
    return {
      teamList: [
        {
          id: 1,
          list: [
            { id: 1, photo: require("@/assets/images/share-table-left.png") },
            { id: 2, photo: require("@/assets/images/share-table-left.png") },
            { id: 3, photo: require("@/assets/images/share-table-left.png") },
            { id: 4, photo: require("@/assets/images/share-table-left.png") },
            { id: 5, photo: require("@/assets/images/share-table-left.png") },
            { id: 6, photo: require("@/assets/images/share-table-left.png") },
            { id: 7, photo: require("@/assets/images/share-table-left.png") },
            { id: 8, photo: require("@/assets/images/share-table-left.png") },
          ],
        },
        {
          id: 2,
          list: [
            { id: 1, photo: require("@/assets/images/share-table-left.png") },
            { id: 2, photo: require("@/assets/images/share-table-left.png") },
          ],
        },
      ],
    };
  },
  components: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style scoped lang="scss">
.select_team_con {
  min-height: 100vh;
  padding: 32px;
  box-sizing: border-box;
  .select_title_con {
    font-size: 32px;
    p {
      margin-bottom: 15px;
      &:last-child {
        font-size: 24px;
      }
    }
  }
  .select_team_list {
    margin-top: 50px;
    li {
      background: #fff;
      border-radius: 16px;
      margin-bottom: 30px;
      .team_img_con {
        padding: 30px 30px 0;
        display: flex;
        flex-wrap: wrap;
        div {
          margin: 0 15px 15px 0;
          img {
            width: 80px;
            height: 80px;
            border-radius: 50%;
          }
        }
      }
      p {
        background: #ac8d5f;
        line-height: 70px;
        text-align: center;
        color: #fff;
        font-size: 28px;
      }
    }
  }
  .select_footer_btn {
    position: fixed;
    left: 0;
    bottom: 20px;
    width: 100%;
    padding: 0 22px;
    box-sizing: border-box;
  }
}
</style>
